export default __webpack_public_path__ + "static/media/edit.e164428e.svg";